<template>
	<section>
		<div class="row ml-3 mt-3 mb-2 mr-3 pt-3 px-3 pb-0">
			<div class="col-5">
				<h4>File</h4>
			</div>
			<div class="col-3">
				<h4>Type</h4>
			</div>
			<div class="col-2">
				<h4>Status</h4>
			</div>
			<div class="col-2 text-right">
				<h4>Actions</h4>
			</div>
		</div>
		<div
			class="file-wrapper w-100 mb-3"
			:class="{ selected: isSelected(item.id) }"
			v-for="(item, index) in displayDocuments"
			:key="`${item.id}-${index}`"
		>
			<input
				:ref="`select-${item.id}-${index}`"
				type="checkbox"
				v-model="selected"
				v-show="false"
				v-if="item.uploaded && selectable"
				:value="{ id: item.id, is_app_document: item.is_app_document }"
			/>
			<div class="file-item row" @click.stop="select(`select-${item.id}-${index}`)">
				<div class="col-5 d-flex align-items-center">
					<div class="icon-item" :class="documentStatuses[item.status]">
						<font-awesome-layers full-width class="fa-2x">
							<font-awesome-icon :icon="['fas', 'file']" />
							<font-awesome-layers-text
								class="fa-inverse"
								transform="shrink-11.5"
								:value="item.filename ? item.filename.split('.').pop() : 'doc'"
								style="font-weight: 400"
							/>
						</font-awesome-layers>
					</div>
					<div class="item-name">
						<span class="name">{{ _.get(item, "name") }}</span>
						<p v-if="_.get(item, 'filename')" class="mb-0 text-grey">
							<small style="text-overflow: ellipsis">{{ _.get(item, "filename") }}</small>
							<el-tooltip class="item" effect="dark" content="Edit filename" placement="top">
								<button
									class="showonhover amb-icon-btn ml-2"
									type="button"
									v-if="item.uploaded"
									@click.stop="renameFilename(item)"
								>
									<font-awesome-icon :icon="['fas', 'pen']" @mousedown.stop />
								</button>
							</el-tooltip>
						</p>
						<p class="mb-0 text-grey">
							{{ item.uploader_name }}, {{ $moment.utc(item.created_at).tz($store.getters.timezone).format("ddd DD/MM/YY LT") }}
						</p>
					</div>
				</div>
				<div class="col-3">
					<span class="item-status">
						<el-tooltip class="item" effect="dark" :content="item.document_type ? item.document_type.name : ''" placement="top">
							<el-tag size="small" @click.stop="changeDocumentTypeModal(item)">
								{{ item.document_type ? item.document_type.name : "Select Document Type" }}
							</el-tag>
						</el-tooltip>
					</span>
				</div>
				<div class="col-2">
					<span class="item-status" v-if="item.url">
						<el-dropdown @command="setStatus" trigger="click">
							<span class="el-dropdown-link">
								<el-tag size="small" :type="documentStatuses[item.status]">{{ item.status }}</el-tag>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="(color, status) in documentStatuses" :key="status" :command="status" :document="item">
									{{ status }}
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</span>
					<span class="item-status" v-else>
						<el-tag size="small" :type="documentStatuses[item.status]">{{ item.status }}</el-tag>
					</span>
				</div>
				<div class="col-2">
					<div class="actions">
						<a v-if="canPreview" :disabled="appCompleted" class="action" @click.stop="previewDocument = item" target="_blank">
							<font-awesome-layers full-width @mousedown.stop>
								<font-awesome-icon :icon="['far', 'file']" />
								<font-awesome-icon :icon="['fas', 'search']" transform="down-8 right-7" />
							</font-awesome-layers>
						</a>
						<file-upload
							class="action"
							:modal="true"
							v-if="!item.is_app_document && canUpload"
							:endpoint="`/api/application/conditioning/${$store.getters.appId}/document/${item.id}`"
							@uploadSuccess="$emit('getDocuments', true)"
							label="Drop documents here to upload <b><em>or</em></b> <span style='text-decoration: underline;'>click to browse</span>"
							:icon="true"
                            :disabled="appCompleted"
						/>
						<el-popconfirm
                             v-if="canDelete"
							confirmButtonText="Trash it!"
							cancelButtonText="No, Thanks"
							icon="el-icon-info"
							iconColor="red"
							title="Are you sure to trash this?"
							@confirm="removeDocument(item)"
                            :disabled="appCompleted"
						>
							<div slot="reference" class="action trash" @click.stop>
								<font-awesome-icon :icon="['fas', 'trash']" @mousedown.stop />
							</div>
						</el-popconfirm>
					</div>
				</div>
			</div>
		</div>
		<el-dialog
			title="Set Document Type"
			:visible.sync="showDocumentTypeModel"
			append-to-body
			width="500px"
			custom-class="set-document-type"
		>
			<el-select
				v-model="newDocumentCategory"
				value-key="id"
				:placeholder="selectedDocument.document_type ? selectedDocument.document_type.name : 'Select Document Type'"
				placeholder="Select"
				class="w-100"
				filterable
				popper-class="document-types"
			>
				<el-option-group v-for="(group, index) in documentTypes.keys()" :key="`option-${group}-${index}`" :label="group">
					<el-option
						v-for="(item, index) in documentTypes.get(group)"
						:key="`value-${item.id}-${index}`"
						:label="`${item.name}`"
						:value="item"
					>
						<span :title="item.name">{{ item.name }}</span>
					</el-option>
				</el-option-group>
			</el-select>
			<br />
			<br />
			<el-checkbox v-model="renameDocument">Rename Document?</el-checkbox>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showDocumentTypeModel = false">Cancel</el-button>
				<el-button type="primary" @click="changeDocumentType">Confirm</el-button>
			</span>
		</el-dialog>

		<x-modal
			class="fileGroup-Preview"
			width="500"
			v-if="previewDocument"
			@close="previewDocument = false"
			@cancel="previewDocument = false"
			:footer="false"
		>
			<div slot="title" :class="`d-flex justify-content-between align-items-center`">Preview Document</div>
			<div>
				<DocumentPreview
					v-if="previewDocument"
					v-bind="{ previewDocument, documentStatuses, documentTypes }"
                    :can-upload="canUpload"
                    :can-delete="canDelete"
                    :can-preview="canPreview"
					:key="previewDocument.id"
					@closePreview="previewDocument = ''"
					@uploadLineFile="uploadLineFile"
				/>
			</div>
		</x-modal>
	</section>
</template>

<script>
	import { mapGetters } from "vuex"

	function groupBy(list, keyGetter) {
		const map = new Map()
		list.forEach((item) => {
			const key = keyGetter(item)
			const collection = map.get(key)
			if (!collection) {
				map.set(key, [item])
			} else {
				collection.push(item)
			}
		})
		return map
	}

	import DocumentPreview from "./DocumentPreview.vue"
	export default {
		name: "FileGroup",
		components: {
			DocumentPreview,
		},
		props: {
			documents: Array,
			selected_docs: Array,
			// docTypes: Array,
			selectable: Boolean,
            canUpload: {
                type: Boolean,
                required: false,
                default: true
            },
            canDelete: {
                type: Boolean,
                required: false,
                default: true
            },
            canPreview: {
                type: Boolean,
                required: false,
                default: true
            },
		},
		data() {
			return {
				documentStatuses: {
					Approved: "success",
					Pending: "warning",
					Rejected: "danger",
				},
				showDocumentTypeModel: false,
				selectedDocument: {},
				newDocumentCategory: {},
				renameDocument: true,
				selected: this.selected_docs,
				isRefAppSubmitted: false,
				previewDocument: false,
				headers: {},
			}
		},
		computed: {
			...mapGetters({
				// docDocuments: 'documents/all',
				docTypes: "documents/fileTypes",
			}),
			appCompleted: function () {
				return this.$store.getters.initAppData.application_status_id == 15 && !this.$store.getters.canEditCompleted
			},

			displayDocuments() {
				return this.documents
			},
			documentTypes() {
				return groupBy(this.docTypes, (doc) => {
					return ((doc.document_type && doc.document_type != "null") || undefined ? doc.document_type : "others").toUpperCase()
				})
			},
		},
		watch: {
			selected(newVal, oldVal) {
				this.$emit("update:selected_docs", newVal)
			},
		},
		mounted() {
			this.isRefAppSubmitted = this.$store.getters["referrer/appSubmitted"]
		},
		updated() {},
		activated() {},
		methods: {
			select(element) {
				const ref = this.$refs[element]
				// return console.warn('TEST: PREVENT SELECT', { element, ref })
				if (!this.selectable || !ref) return
				let el = ref[0]
				el.click()
			},
			isSelected(id) {
				if (!this.selectable) return
				return this.selected.find((doc) => {
					return doc.id === id
				})
			},
			fileex(filetype) {
				return `fa fa-${filetype}`
			},
			changeDocumentTypeModal(item) {
				this.showDocumentTypeModel = true
				this.selectedDocument = item
			},
			changeDocumentType() {
				this.selectedDocument.document_type_id = this.newDocumentCategory.id
				if (this.renameDocument) {
					let cat = this.docTypes.find((item) => {
						return item.id == this.newDocumentCategory.id
					})
					if (cat.default_filename) {
						this.selectedDocument.filename = `${cat.default_filename}.${this.selectedDocument.type}`
					}
				}

				this.changeDocCategory(this.selectedDocument)
				this.selectedDocument = {}
				this.newDocumentCategory = {}
				this.selectedGroup = ""
				this.showDocumentTypeModel = false
				this.renameDocument = true
			},
			changeDocCategory(payload) {
				let doc = _.get(payload, "doc", payload)
				axios
					.put(
						"/api/application/" + this.$store.getters.initAppData.id + "/finalise/documents/" + doc.id,
						{
							document_type_id: doc.document_type_id,
							is_app_document: doc.is_app_document,
							document_category: doc.doc_category,
							status: doc.status,
							file_name: doc.filename,
						},
						{
							headers: {
								Authorization: "Bearer " + this.$store.getters.token,
							},
						}
					)
					.then((res) => {})
			},
			setStatus(status, item) {
				item.$attrs.document.status = status
				this.$emit("changeFileType", item.$attrs.document)
			},
			renameFilename(item) {
				item.filename.split(".").pop()
				let name = item.filename.split(".")[0]
				this.$prompt("", "Rename Document", {
					confirmButtonText: "Rename",
					cancelButtonText: "Cancel",
					closeOnClickModal: false,
					closeOnPressEscape: false,
					inputPattern: /^[a-zA-Z0-9 _-]*$/,
					inputErrorMessage: "Please do not use special characters",
					inputValue: item.filename ? name : "",
				})
					.then(({ value }) => {
						this.rename(item, value)
					})
					.catch(() => {})
			},
			rename(item, value) {
				let res = axios.put(
					`/api/v2/applications/${this.$store.getters.initAppData.id}/documents/${item.id}`,
					{
						filename: `${value}.${item.type}`,
						name: value,
					},
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.token}`,
						},
					}
				)
				item.filename = `${value}.${item.type}`
				this.$message({
					message: "Renamed Document to: " + `${value}.${item.type}`,
					type: "success",
				})
			},
			removeDocument(item) {
				this.$emit("deleteDocument", item)
			},
			uploadFileLine(e, doc) {
				let file = e.target.files[0]
				this.uploadLineFile({ file: file, id: doc.id })
			},
			uploadPending(item) {
				if (!item.is_app_document) {
					let el = this.$refs["upload_field_" + item.id][0]
					el.click()
				}
			},
			async uploadLineFile(data) {
				try {
					// form data
					let headers = {
						headers: {
							Authorization: "Bearer " + this.$store.getters.token,
							"Content-Type": "multipart/form-data",
						},
					}
					let formData = new FormData()
					formData.append("file", data.file)
					let res = await axios.post(
						"/api/application/conditioning/" + this.$store.getters.appId + "/document/" + data.id,
						formData,
						headers
					)
					this.$emit("getDocuments", true)
					this.$message({
						message: "File Uploaded",
						type: "success",
					})
				} catch (err) {
					console.error(err)
					this.$message({
						message: "Upload Failed",
						type: "error",
					})
				}
			},
			viewDocument(doc) {
				axios
					.get(
						"/api/application/" +
							this.$store.getters.initAppData.id +
							"/finalise/documents/" +
							doc.id +
							"?is_app_document=" +
							doc.is_app_document,
						{
							headers: {
								Authorization: `Bearer ${this.$store.getters.token}`,
							},
						}
					)
					.then((res) => window.open(res.data))
			},
		},
	}
</script>

<style lang="scss" scoped>
	.file-wrapper {
		background-color: #fff;
		border: 1px solid transparent;
		.file-item {
			width: 100%;
			display: flex;
			align-items: center;
			padding: 7px;
			cursor: pointer;
			margin: 0;

			.icon-item {
				text-align: center;
				position: relative;
				flex: 0 0 50px;
				line-height: 0;
				margin-right: 20px;
				color: #f1f2f3;

				.fa-folder,
				.fa-file-image,
				.fa-file-pdf,
				.fa-folder-open {
					font-size: 3.25em;
				}

				.fa-layers-text {
					color: #2593ef;
				}
			}

			.item-name {
				display: block;
				color: #242b46;
				width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

				.name {
					font-weight: 600;
					user-select: text;
					display: block;
					font-size: 0.875em;
					max-height: 48px;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.item-length {
					font-size: 0.75em;
					font-weight: 400;
					color: #667b90;
					display: block;
				}
			}

			.showonhover {
				opacity: 0;
			}

			&:not(.folder) {
				&.grabbing {
					cursor: grabbing !important;
				}
				&:hover,
				&:focus {
					border-radius: 0.5rem;
					background-color: #f5f5f5;
					.icon-item {
						&.success {
							color: #67c23a;
						}
						&.warning {
							color: #e6a23c;
						}
						&.danger {
							color: #f56c6c;
						}

						.fa-layers-text {
							color: transparent;
						}
					}

					.showonhover {
						opacity: 1;
					}
				}
			}

			.actions {
				display: flex;
				justify-content: flex-end;
				align-items: center;

				.action {
					margin-left: 1rem;

					&.trash {
						color: rgb(238, 65, 35);
					}
				}
			}
		}

		&.selected {
			border: 1px solid #5cbb2b;
		}
	}
</style>
<style lang="scss">
	.fileGroup-Preview {
		.modal-body {
			padding: 0;
			overflow: hidden;

			section {
				&.preview {
					min-height: 60vh;
					padding: 15px 15px 0 15px;
					.document {
						margin-bottom: 15px;
					}
					.details {
						height: 170px !important;
					}
					.actions {
						height: 60px !important;
					}
				}
			}
		}
	}

	.item-status {
		.el-tag {
			overflow: hidden;
			max-width: 170px;
			text-overflow: ellipsis;
		}
	}
	.document-types {
		max-width: 470px;
	}
	.el-tag {
		cursor: pointer !important;
	}
	.el-dialog__wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		.set-document-type {
			margin: 0 !important;
		}
	}
</style>
